module.exports = __webpack_public_path__ + "img/bg-header@3x.94dd9d2.jpg";